import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import WidgetsBacktesting from 'components/WidgetsBacktesting';
import WinRatePieChartBacktesting from 'components/WinRatePieChartBacktesting';
import PnLChartBacktesting from 'components/PnLChartBacktesting';
import ProfitFactorGaugeBacktesting from 'components/ProfitFactorGaugeBacktesting';
import RiskOverTimeChartBacktesting from 'components/RiskOverTimeChartBacktesting';

const DataWidgets = ({ metrics = {}, compareMode }) => {
  console.log('Metrics in DataWidgets:', metrics);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <WidgetsBacktesting metrics={metrics} />
      </Grid>
      {compareMode ? (
        <>
          <Grid item xs={12} md={6}>
            <WinRatePieChartBacktesting metrics={metrics} />
          </Grid>
          <Grid item xs={12} md={6}>
            <WinRatePieChartBacktesting metrics={metrics} />
          </Grid>
        </>
      ) : (
        <Grid item xs={12} md={6}>
          <WinRatePieChartBacktesting metrics={metrics} />
        </Grid>
      )}
    </Grid>
  );
};

DataWidgets.propTypes = {
  metrics: PropTypes.object,
  compareMode: PropTypes.bool.isRequired,
};

export default DataWidgets;